import { FundPriceSetsService_fundPriceSetsServiceGetLatestPrice } from '@festina/unitlink-general-types/unitlink/hooks/FundPriceSetsService_fundPriceSetsServiceGetLatestPrice'

export const useLazyFetchFundPrice =
  FundPriceSetsService_fundPriceSetsServiceGetLatestPrice.useLazyQuery
